const RECENT_EMOJIS_STORAGE_KEY = 'littlebird:emoji-picker:recents';
export const RECENT_EMOJIS_LIMIT = 8;
// Fills the row until the viewer has picked enough of their own
const STARTER_EMOJIS = ['👍', '❤️', '😂', '🎉', '🙏', '👀', '✅', '🚀'];

function readStoredRecents(): string[] {
  try {
    const stored: unknown = JSON.parse(
      localStorage.getItem(RECENT_EMOJIS_STORAGE_KEY) ?? '[]'
    );
    return Array.isArray(stored)
      ? stored.filter((entry): entry is string => typeof entry === 'string')
      : [];
  } catch {
    return [];
  }
}

export function readRecentEmojis(): string[] {
  const recents = readStoredRecents();
  const starters = STARTER_EMOJIS.filter((emoji) => !recents.includes(emoji));
  return [...recents, ...starters].slice(0, RECENT_EMOJIS_LIMIT);
}

export function writeRecentEmoji(emoji: string): void {
  const recents = [
    emoji,
    ...readStoredRecents().filter((entry) => entry !== emoji),
  ].slice(0, RECENT_EMOJIS_LIMIT);
  try {
    localStorage.setItem(RECENT_EMOJIS_STORAGE_KEY, JSON.stringify(recents));
  } catch {
    // A viewer without storage keeps the starter row
  }
}
